module.exports = __webpack_public_path__ + "img/celular.028123e5.png";